<template>
	<div class="indexbg">
		<topbar></topbar>
		<header></header>
		<emallheader ref="eh"></emallheader>
		<div class="clear mt15"></div>

		<!--container 开始-->
		<div class="w1200 bc">
			<!--开始-->
			<div class="hq-shopping-cart">

				<!--我的购物车：开始-->
				<div class="bd-box buycart-list mt20">
					<div class="hd">
						<dl>
						<dt class="col-2">Product information</dt>
						<dt class="col-4">Quantity</dt>
						<dt class="col-5">Unit</dt>
						</dl>
					</div>
					<div class="bd">
						<div>
							<dl>
								<dd class="col-2" style="position: relative;">
									<a class="pic fl">
										<img v-bind:src="goodsBo.imgSmall" width="118" height="100" v-on:click="toDetail(goodsBo.goodsCode)">
									</a>
									<p class="title">
										 <a class="co-b-2 name"  v-on:click="toDetail(goodsBo.goodsCode)">{{ goodsBo.goodsNameEn }}</a>
									</p>
								</dd>
								<dd class="col-4" >
									<div class="item-amount">
										<input v-model="quantityNum" class="text-amount" min="1" max="9999999" type="number" maxlength="7">
									</div>
								</dd>
								<dd class="col-5 co-r-1 f14" >
									<select v-model="valuationUnit" name="valuationUnit" class="city_select_css">
										<option value="price">price</option>
										<option value="set/sets">set/sets</option>
									</select>
								</dd>
							</dl>
							<dl>
								<dd style="position: relative;">
									<label>Message：</label>
									<textarea v-model="msgContext" name="msgContext" cols="100" rows="5"></textarea>
								</dd>
							</dl>
							<dl>
								<dd style="position: relative;">
									<label>Please enter email address：</label><br/>
									<input v-model="emailAddress" name="emailAddress" class="inpt" type="text"/>
								</dd>
							</dl>
						</div>
						
						<div class="total tr co5">
							<ul>
								<li class="fr" style="">
									<input class="a-btn-c-2" name="sendInquiryButton" type="button" value="Send inquiry now" v-on:click="sendInquiry()"/>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<!--结束-->

			<div class="clear"></div>

		</div>
		<!--container 结束-->
		<div class="clear"></div>
		<footermenu></footermenu>
		<footercopyright></footercopyright>
	</div>
	<!--底部 结束-->

	</div>
</template>

<script>
	
	import TopBar from '@/components/TopBar'
	import EmallHeader from '@/components/Header'
	import FooterMenu from '@/components/FooterMenu'
	import ShopNav from '@/components/ShopNav'
	import FooterCopyright from '@/components/FooterCopyright'
	import API from "../../../static/api/api.js"
	import alertConfirm from "../../../static/js/alertConfirm.js"
	import jQuery from 'jquery';
	import {getAjaxUrl,getUcUrl,getImgUrl,dateFormat,getValueFromMap,showMoney,parseResult,ak} from "../../../static/js/emallUtils.js"
	import MintUI from 'mint-ui'
	import 'mint-ui/lib/style.css'
	import {MP} from '../../../static/js/map.js'
	//没用
//	import MessageBox from 'mint-ui'
	import Vue from 'vue'
	import VueRouter from 'vue-router'
	Vue.use(VueRouter)
	Vue.use(MintUI)
	//没用
//	Vue.use(MessageBox)
//	Vue.component(MessageBox.name,MessageBox);
	
	export default {
		name: 'shopcart',
		data() {
			return{
					goodsCode:'',
					goodsBo:{},
					quantityNum:1,
					valuationUnit:"price",
					msgContext:"",
					emailAddress:""
				}
		},
		components: {
			'topbar': TopBar,
			'shopnav': ShopNav,
			'emallheader': EmallHeader,
			'footermenu': FooterMenu,
			'footercopyright': FooterCopyright
		},
		methods:{
			//跳转到产品详情
			toDetail:function(goodsCode){
				//this.$router.push({ path: '/goodsDetails', query:{goodsCode:goodsCode}});
				let routeData = this.$router.resolve({ path: '/goodsDetails', query: {goodsCode: goodsCode } });
				window.open(routeData.href, '_blank');
			},
			//得到产品信息
         	getGoodDetail:function(goodsCode){
         		var that=this;
			 	this.$http.jsonp(getAjaxUrl()+'/goods/ajax_goods_physical_detail.htm',
			 		{
			 			params:{goodsCode:goodsCode}
			 		}).then(
			 		function (ret){


			 			//------------------取商品其它信息--------------------
			 			var good =  ret.body.data.goods;
			 			if(good != undefined){
					 		var imgSmall = good.imgSmall;
			                    if(imgSmall.indexOf(";")!=-1){
			                    	imgSmall=imgSmall.split(";")[0];
			                    }
					 		good.imgSmall = getImgUrl()+"/upload/show.htm?filePath="+imgSmall;
			 				that.goodsBo = good;
			 			}
			 			if(that.orderType==undefined||that.orderType==''){
			 				if(good.productType=="meterial"){
				 				that.orderType="purchase";
				 			}else if(good.productType=="sample"){
				 				that.orderType="custom";
				 			}else if(good.productType=="product"){
				 				that.orderType="spot";
				 			}else{
				 				that.orderType="custom";
				 			}
			 			}

						that.attrValue = JSON.parse(good.attrValue);
						//产品详情图片路径添加绝对路径
			 			that.goodsDesc = good.goodsDesc.replace(/\/upload\//g, API.getImgPath()+"/upload/");
			 			that.goodsDescEn = good.goodsDescEn.replace(/\/upload\//g, API.getImgPath()+"/upload/");
			 			that.goodsName = good.goodsName;
			 			that.goodsNameEn = good.goodsNameEn;
			 			that.catCode = good.catCode;
			 			that.firstCatCode = that.attrValue.firstCatCode;
			 			//从返回的类目对象中获取英文名称
			 			var goodsCatInfo =  ret.body.data.goodsCatInfo;
			 			if(goodsCatInfo != undefined){
			 				that.goodsCatName = goodsCatInfo.catName;
			 			}
			 			
			 			//这个地方估计有坑~
			 			var imgArray = [];
			 			 if(good.imgLarge.indexOf(";")!=-1){
			 			 	good.imgLarge=good.imgLarge.substring(0,good.imgLarge.length-1);
                    		that.goodsImgs=good.imgLarge.split(";");
                    		good.imgLarge = that.goodsImgs[0];
                    	}
			 			that.goodsImgLarge =  getImgUrl()+"/upload/show.htm?filePath="+good.imgLarge;
			 			for (var j = 0;j<that.goodsImgs.length;j++) {
			 				that.goodsImgs[j] =  getImgUrl()+"/upload/show.htm?filePath="+that.goodsImgs[j];
			 			}

						that.goodsNumber = good.goodsNumber
						that.discount = (that.goodsPrice / that.marketPrice * 10).toFixed(2);
			 			that.breaks = parseFloat(that.marketPrice-that.goodsPrice).toFixed(2);
			 			that.saleNumber  = good.saleNumber;
			 			that.inpSaleNumber  = good.inpSaleNumber;
			 			that.shopCode = good.shopCode;
			 			that.shopName = good.shopName;
			 			that.shopNameEn = good.shopNameEn;

			 			var goodsSkuMap = that.goodsSkuMap;
			 			var goodsSkuList =  ret.body.data.goodsSkuList;

			 			that.getShopInfo(good.shopCode);

			 		},  function (err){
//			 			alertConfirm.singleConfirm("异步请求操作失败")
			 		}
			 	)
			},
			//获取店铺信息
           	getShopInfo:function(shopCode){
        		var that=this;
			 	this.$http.jsonp(getAjaxUrl()+'/shop/ajax_shop_index.htm',{
			 		params: {shopCode:shopCode}
				 }).then(
			 		function (ret){
			 			if(ret.body.code == "success"){
			 				var info =ret.body.data.shopBo;
				 			that.shopInfo = info
				 			if(info.shopLogo!=undefined&&info.shopLogo!=""){
				 				that.shopLogo =	getImgUrl()+"/upload/show.htm?filePath="+info.shopLogo;
				 			}
				 		 	if(info.qq == undefined || info.qq ==''){
				 				that.qqUrl = "javascript:volid(0);";
				 			}else{
				 				that.qqUrl = "http://wpa.qq.com/msgrd?v=3&site=qq&menu=yes&uin="+info.qq;
				 			}
			 			}
			 		},function (err){
//			 			alertConfirm.singleConfirm("异步查询店铺信息失败")
			 		})
        	},
        	//附件上传
        	
			//数据提交
			sendInquiry:function(){
        			var that = this;
        			//
        			var productCode = that.goodsCode;
        			//数量
					var quantityNum = that.quantityNum;
					//单位
					var valuationUnit = encodeURI(that.valuationUnit);
        			//描述
					var msgContext = encodeURI(that.msgContext);
					//地址
					var emailAddress = encodeURI(that.emailAddress);

					API.sendContactSupplierEmail(productCode,quantityNum,valuationUnit, msgContext, emailAddress,function(ret) {
							if(ret.code != null && ret.code == "success") {
								alertConfirm.singleConfirm("Contact supplier submitted successfully",function(){
									window.location.reload();
								});
								//window.location.reload();
							} else if(ret.code != null && ret.code == "9999") {
								alertConfirm.singleConfirm("Log in first, please！");
								window.location.href = getUcUrl() + '/login.htm';
								return false;
							} else if(ret) {
								var errorCode = ret.code;
								var errorMsg = 'The system is busy, please try again later';
								alertConfirm.singleConfirm(errorMsg);
							}
						});

        	}
//      	orderCommit:function(){
//      		var that = this;
//      		this.$router.push({ name: 'ordercommit', params:{bos:that.boList}});
//      	},
		},
		beforeMount:function(){
			var that = this;
			var goodsCode = "";
			if(that.$route.params.goodsCode != undefined){
				goodsCode = that.$route.params.goodsCode;
			}
			if(that.$route.query.goodsCode != undefined){
				goodsCode = that.$route.query.goodsCode;
			}
			this.goodsCode=goodsCode;
			this.getGoodDetail(goodsCode);
		},
		mounted(){			
			window.scrollTo(0, 0);
//			alertConfirm.init();
//			this.getShoppingCartNum();
//			this.getCartList();
		}
	}
</script>

<style>
.mint-msgbox{
	width:50%
}
.delisting-color{
	color:#999;
}
</style>


// WEBPACK FOOTER //
// src/page/goods/contactSupplier.vue